import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useNotesPopUp() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.editNotesPopUpState, ...args };
    updateGlobalState({ editNotesPopUpState: newState });
  };

  return {
    close: () => setState({ isOpen: false, workBlockId: null, workOrderId: null }),
    isOpen: state.editNotesPopUpState.isOpen,
    open: ({ workOrderId, workBlockId }) => setState({ isOpen: true, workBlockId, workOrderId }),
    workBlockId: state.editNotesPopUpState.workBlockId,
    workOrderId: state.editNotesPopUpState.workOrderId,
  };
}
